/**
 * Triggers a subtle tactile haptic vibration on supported mobile devices (e.g., Android).
 *
 * @param duration Duration in milliseconds (default: 12ms for subtle tap feel).
 */
export function triggerHaptic(duration = 12): void {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate(duration);
    } catch {
      // Ignore vibration errors (e.g. permission or background tab restrictions)
    }
  }
}
